module.exports = "/_next/static/images/2d958b8b809425daf0fe5a325930808e-website-mgm-thumb-large.jpg";